import { Person } from '@/types/person';

import isEligibleForPostScheduledIntake from './checkPSIEligibility';
import isEligibleForSelfScheduledIntake from './checkSSIEligibility';

export interface PSIStep {
  id: string;
  classificationKey: string;
  title: string;
  tooltip: string;
  link: (personId: string) => string;
  shouldShow: (person: Person) => boolean;
}

const intakeOrPSIEligible = (person: Person): boolean =>
  isEligibleForSelfScheduledIntake(person) || isEligibleForPostScheduledIntake(person);

const alwaysShow = (): boolean => true;

const PSI_STEPS: readonly PSIStep[] = [
  {
    id: 'documents_signed',
    classificationKey: 'self_scheduling_intake.documents_completed',
    title: 'Documents Signed',
    tooltip: 'All intake documents have been signed',
    link: (personId) => `/people/${personId}/documents`,
    shouldShow: intakeOrPSIEligible
  },
  {
    id: 'intake_scheduled',
    classificationKey: 'has_scheduled_intake',
    title: 'Intake Appointment Scheduled',
    tooltip: 'An intake appointment has been scheduled',
    link: (personId) => `/people/${personId}/appointments`,
    shouldShow: alwaysShow
  },
  {
    id: 'prepare_for_your_intake_challenge',
    classificationKey: 'psi_challenge_completed.preparing-for-your-intake',
    title: 'Prepare for your intake Challenge',
    tooltip: 'Person has completed the required "Prepare for your intake" challenge',
    link: (personId) => `/people/${personId}/timeline?search=Prepare+for+your+intake`,
    shouldShow: alwaysShow
  },
  {
    id: 'community_challenge_completed',
    classificationKey: 'psi_challenge_completed.community_challenge_completed',
    title: 'Community Challenge',
    tooltip:
      'Person has completed the required "Find your circle" or "You\'re not alone" challenge',
    link: (personId) =>
      `/people/${personId}/timeline?search=Find+your+circle&search=Youre+not+alone`,
    shouldShow: alwaysShow
  },
  {
    id: 'intake_confirmed',
    classificationKey: 'has_confirmed_intake',
    title: 'Intake Appointment Confirmed',
    tooltip: 'An intake appointment has been confirmed',
    link: (personId) => `/people/${personId}/appointments`,
    shouldShow: alwaysShow
  },
  {
    id: 'has_member_availability',
    classificationKey: 'has_member_availability',
    title: 'Member Availability Set',
    tooltip: 'Member has set their availability',
    link: (personId) => `/people/${personId}/availability`,
    shouldShow: alwaysShow
  }
];

export default PSI_STEPS;
